import customWebDesignImg from '../asset/services/customwebdesign2.webp';
import wordPressDevImg from '../asset/services/wordpressdev.webp';
import mobileDesignImg from '../asset/services/mobileresponsivedesign2.webp';
import eCommImg from '../asset/services/ecommerce3.webp';
import appDevImg from '../asset/services/appdev2.webp';
import socialMediaImg from '../asset/services/socialmedia2.webp';
import ContentCreationImg from '../asset/services/Content_Creation .webp';
import InfluencerMarketingImg from '../asset/services/Influencer_Marketing.webp';
import AIAndMachineLearningImg from '../asset/services/ai_and_machine_learning.webp';
import KeywordsResearchImg from '../asset/services/Keywords_Research.webp';
import OnPageSEOImg from '../asset/services/on_page_seo.webp';
import OfPageSEOImg from '../asset/services/off_page_seo.png';
import TechinalSEOImg from '../asset/services/Technical_Seo.webp';
import SearchEngineOptimizationImg from '../asset/services/search_engine_optimization.webp';
import LocalKeywordsImg from '../asset/services/local_keywords_research.webp';
import AdCreationAndTestingImg from '../asset/services/ad-creation-and-testing.webp';
import CampaignSetupImg from '../asset/services/campaign_setup.webp';

export const servicesData = [
  // ---- Development Services ----
  {
    slug: 'custom-web-development',
    category: 'Development Services',
    title: 'Custom Website Design',
    shortTitle: 'Web Design',
    image: customWebDesignImg,
    color: '#3b82f6',
    tagline: 'Websites that work as hard as you do.',
    description: 'We craft high-performance, scalable web applications tailored to your business goals. From elegant landing pages to complex enterprise portals, we ensure every pixel serves a purpose.',
    features: ['React & Next.js', 'UI/UX Design', 'Performance Optimization'],
  },
  {
    slug: 'wordpress-web-development',
    category: 'Development Services',
    title: 'WordPress Development',
    shortTitle: 'WordPress',
    image: wordPressDevImg,
    color: '#0ea5e9',
    tagline: 'Beautiful. Flexible. Easy to manage.',
    description: 'Empower your team with a flexible, easy-to-manage WordPress ecosystem. We build custom themes and plugins that extend the core capabilities of the world\'s most popular CMS.',
    features: ['Custom Themes', 'WooCommerce', 'Security Hardening'],
  },
  {
    slug: 'responsive-web-development',
    category: 'Development Services',
    title: 'Mobile-Responsive Design',
    shortTitle: 'Mobile Design',
    image: mobileDesignImg,
    color: '#f59e0b',
    tagline: 'Flawless across all devices.',
    description: 'Reach your audience wherever they are. We ensure your digital presence is pixel-perfect and lightning-fast on every screen, from the smallest smartphone to the largest desktop monitor.',
    features: ['Responsive Layouts', 'Touch Optimization', 'Cross-browser Testing'],
  },
  {
    slug: 'ecommerce-website-development',
    category: 'Development Services',
    title: 'E-Commerce Website',
    shortTitle: 'E-Commerce',
    image: eCommImg,
    color: '#10b981',
    tagline: 'Sell more, faster.',
    description: 'Transform your online store into a high-conversion machine. We build robust e-commerce platforms that handle everything from complex inventory to seamless multi-currency checkout.',
    features: ['Payment Gateways', 'Inventory Management', 'Customer Analytics'],
  },
  {
    slug: 'custom-app-development',
    category: 'Development Services',
    title: 'Custom App Development',
    shortTitle: 'App Dev',
    image: appDevImg,
    color: '#8b5cf6',
    tagline: 'Native experiences. Cross-platform reach.',
    description: 'Build powerful mobile applications for iOS and Android that users love. We leverage React Native and Flutter to deliver native performance with efficient, cross-platform codebases.',
    features: ['React Native', 'Flutter', 'Native iOS/Android'],
  },
  {
    slug: 'cloud-solutions-services',
    category: 'Development Services',
    title: 'Cloud Solutions & Services',
    shortTitle: 'Cloud Solutions',
    image: socialMediaImg,
    color: '#3b82f6',
    tagline: 'Scale infinitely. Operate efficiently.',
    description: 'Future-proof your infrastructure with our enterprise-grade cloud solutions. We handle everything from migration strategy to high-availability architecture on AWS, Azure, and GCP.',
    features: ['Cloud Migration', 'AWS/Azure/GCP', 'DevOps Pipelines'],
  },

  // ---- AI Powered Marketing ----
  {
    slug: 'content-creation-services',
    category: 'AI Powered Marketing',
    title: 'Content Creation',
    shortTitle: 'Content',
    image: ContentCreationImg,
    color: '#ec4899',
    tagline: 'AI-driven content that resonates.',
    description: 'Scale your content strategy without losing your soul. We use advanced AI tools to generate high-quality blog posts, social media updates, and marketing copy tailored to your brand voice.',
    features: ['Blog Posts', 'Social Media Copy', 'Video Scripts'],
  },
  {
    slug: 'social-media-advertising',
    category: 'AI Powered Marketing',
    title: 'Social Media Advertising',
    shortTitle: 'Social Ads',
    image: socialMediaImg,
    color: '#3b82f6',
    tagline: 'Targeted ads that convert.',
    description: 'Maximize your ROI with data-driven social campaigns. We combine AI audience analysis with creative storytelling to capture attention on Facebook, Instagram, LinkedIn, and X.',
    features: ['Audience Targeting', 'A/B Testing', 'ROI Tracking'],
  },
  {
    slug: 'influencer-marketing',
    category: 'AI Powered Marketing',
    title: 'Influencer Marketing',
    shortTitle: 'Influencers',
    image: InfluencerMarketingImg,
    color: '#8b5cf6',
    tagline: 'Amplify your reach.',
    description: 'Partner with voices your audience trusts. We use AI to match your brand with the perfect influencers, ensuring your message reaches the right people through authentic connections.',
    features: ['Influencer Sourcing', 'Campaign Management', 'Metric Analysis'],
  },
  {
    slug: 'ai-and-ml-services',
    category: 'AI Powered Marketing',
    title: 'AI and Machine Learning',
    shortTitle: 'AI & ML',
    image: AIAndMachineLearningImg,
    color: '#8b5cf6',
    tagline: 'Intelligent systems that think.',
    description: 'Unleash the power of data. We build custom machine learning models that automate complex tasks, predict user behavior, and provide insights that give you a competitive edge.',
    features: ['Predictive Analytics', 'Natural Language Processing', 'Chatbots'],
  },

  // ---- AIO Optimization ----
  {
    slug: 'keyword-research-services',
    category: 'AIO Optimization',
    title: 'Keyword Research',
    shortTitle: 'Keywords',
    image: KeywordsResearchImg,
    color: '#10b981',
    tagline: 'Find what your users are searching for.',
    description: 'Stop guessing and start ranking. We identify the high-intent keywords your customers are actually using, mapping out a content strategy that targets growth and conversions.',
    features: ['Competitor Analysis', 'Search Intent', 'Trend Analysis'],
  },
  {
    slug: 'on-page-seo-services',
    category: 'AIO Optimization',
    title: 'On-Page SEO',
    shortTitle: 'On-Page',
    image: OnPageSEOImg,
    color: '#f59e0b',
    tagline: 'Optimize your pages for search.',
    description: 'Ensure every page on your site is built to rank. From meta-architecture to internal linking and semantic content optimization, we make your site clear to both users and search bots.',
    features: ['Meta Tags', 'Content Optimization', 'Internal Linking'],
  },
  {
    slug: 'off-page-seo-services',
    category: 'AIO Optimization',
    title: 'Off-Page SEO',
    shortTitle: 'Off-Page',
    image: OfPageSEOImg,
    color: '#3b82f6',
    tagline: 'Build authority beyond your site.',
    description: 'Growth happens outside your website too. We build your domain authority through ethical link-building, PR outreach, and strategic partnerships that signal quality to search engines.',
    features: ['Backlink Building', 'Guest Posting', 'PR Outreach'],
  },
  {
    slug: 'technical-seo-services',
    category: 'AIO Optimization',
    title: 'Technical SEO',
    shortTitle: 'Tech SEO',
    image: TechinalSEOImg,
    color: '#ef4444',
    tagline: 'A solid foundation for search.',
    description: 'Fix the hidden issues holding you back. We optimize site speed, fix crawl errors, implement schema markup, and ensure your site architecture is perfectly tuned for performance.',
    features: ['Site Speed', 'XML Sitemaps', 'Schema Markup'],
  },
  {
    slug: 'seo-services',
    category: 'AIO Optimization',
    title: 'Search Engine Optimization',
    shortTitle: 'SEO',
    image: SearchEngineOptimizationImg,
    color: '#ef4444',
    tagline: 'Rank higher. Reach further.',
    description: 'Our holistic SEO approach combines technical excellence with creative content to drive sustainable organic traffic that compounds over time without increasing your ad spend.',
    features: ['Technical Audits', 'Content Strategy', 'Monthly Reporting'],
  },

  // ---- Google Services ----
  {
    slug: 'local-keyword-research-services',
    category: 'Google Services',
    title: 'Local Keyword Research',
    shortTitle: 'Local Keywords',
    image: LocalKeywordsImg,
    color: '#3b82f6',
    tagline: 'Dominate your local market.',
    description: 'Capture customers in your neighborhood. We find the hyper-local search terms that drive foot traffic and local leads to your business, ensuring you\'re the first one they find.',
    features: ['Geo-targeting', 'Local Intent', 'Voice Search'],
  },
  {
    slug: 'map-and-citation-services',
    category: 'Google Services',
    title: 'Map & Citation Pages',
    shortTitle: 'Google Maps',
    image: ContentCreationImg,
    color: '#f59e0b',
    tagline: 'Get found on Google Maps.',
    description: 'Own your local map pack. We optimize your Google Business Profile and manage citations across the web to ensure you rank at the top for local searches and maps.',
    features: ['Google Maps SEO', 'NAP Consistency', 'Review Management'],
  },
  {
    slug: 'ad-creation-services',
    category: 'Google Services',
    title: 'Ad Creation & Testing',
    shortTitle: 'Google Ads',
    image: AdCreationAndTestingImg,
    color: '#10b981',
    tagline: 'Ads that actually work.',
    description: 'Stop wasting money on poor-performing ads. We design, write, and A/B test Google Ads that capture attention and drive conversions through high-relevance messaging.',
    features: ['Copywriting', 'Ad Design', 'Conversion Tracking'],
  },
  {
    slug: 'campaign-setup-services',
    category: 'Google Services',
    title: 'Campaign Setup',
    shortTitle: 'Setup',
    image:CampaignSetupImg,
    color: '#8b5cf6',
    tagline: 'Launch with precision.',
    description: 'Start your PPC journey on the right foot. We handle the full technical setup of your Google Ads campaigns, from keyword bidding strategies to conversion tracking pixels.',
    features: ['Keyword Bidding', 'Conversion Pixels', 'Budget Planning'],
  },
];
